import { ICareMap, NEW_ALLERGY_ID, NEW_DIAGNOSIS_ID, NEW_MEDICATION_ID } from '../caremap/ICareMap';
import { InnerhivePage } from '../InnerhivePage';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';
import { ActiveCareMapProviderV2 } from '../ActiveCareMapProvider';
import { ActivePatientView } from '../household/ActivePatientView';
import { EditPatientDrawer } from '../household/patient/EditPatientDrawer';
import { QuickAddButtons } from './QuickAddButtons';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { useEffect } from 'react';
import { CareTabsProvider } from './CareTabsProvider';
import { CareRecipientSwitcher } from '../navigation/CareRecipientSwitcher';
import { MedicationEditorDrawer } from '../household/patient/MedicationEditorDrawer';
import { AllergyEditorDrawer } from '../household/AllergyEditorDrawer';
import { DiagnosisEditorDrawer } from '../household/DiagnosisEditorDrawer';

export const CarePage: React.FC<{ caremapId: string; }> = ({ caremapId }) => {
    const caremapState = useInstance(CareMapState);
    useSubscription(() => caremapState);

    return (
        <ActiveCareMapProviderV2 careMapId={caremapId}>
            <CarePageWithCaremap />
        </ActiveCareMapProviderV2>
    );
};

export const CarePageWithCaremap: React.FC = () => {
    const caremapState = useInstance(CareMapState);
    const editPatientDrawer = useInstance(EditPatientDrawer);
    const editMedicationDrawer = useInstance(MedicationEditorDrawer);
    const editAllergyDrawer = useInstance(AllergyEditorDrawer);
    const editDiagnosisDrawer = useInstance(DiagnosisEditorDrawer);
    const mixpanel = useInstance(MixPanelEventEmitter);
    const tabsProvider = useInstance(CareTabsProvider);

    const caremap = caremapState.getActiveCaremap() as ICareMap;

    useEffect(() => {
        mixpanel.track('Care Profile Tab Opened');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!caremap){
        return null;
    }

    const openEditPatientDrawer = () => {
        editPatientDrawer.open();
    };

    return (
        <InnerhivePage title="Care" tabs={tabsProvider.getTabs()}>
            <div style={{paddingBottom: 18}}>
                <CareRecipientSwitcher />
            </div>

            <ActivePatientView
                allowDelete
                hideNotes
                hideAppointments
                onEdit={openEditPatientDrawer}
                onMedicationClick={(id) => editMedicationDrawer.open({ id })}
                onAddMedication={() => editMedicationDrawer.open({ id: NEW_MEDICATION_ID })}
                onAllergyClick={(id) => editAllergyDrawer.open({ id })}
                onAddAllergy={() => editAllergyDrawer.open({ id: NEW_ALLERGY_ID })}
                onDiagnosisClick={(id) => editDiagnosisDrawer.open({ id })}
                onAddDiagnosis={() => editDiagnosisDrawer.open({ id: NEW_DIAGNOSIS_ID })}
            />

            <QuickAddButtons trackingFrom="Care Profile" />
        </InnerhivePage>
    );
};
